// extracted by mini-css-extract-plugin
module.exports = {"companyLogo":"stylesAssignedCompanies_companyLogo__kYrbq","menuLinks":"stylesAssignedCompanies_menuLinks__2Dwmg","active":"stylesAssignedCompanies_active__1r_9G"};